import { render } from "./MainHeaderBasketButton.vue?vue&type=template&id=e6572f7e&scoped=true"
import script from "./MainHeaderBasketButton.vue?vue&type=script&lang=js"
export * from "./MainHeaderBasketButton.vue?vue&type=script&lang=js"

import "./MainHeaderBasketButton.vue?vue&type=style&index=0&id=e6572f7e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6572f7e"]])

export default __exports__